import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

// Type for the plan creation payload
type ToggleStatusPayload = {
    id: string;
};

// Mutation function that calls the API
export const toggleStore = async (payload: ToggleStatusPayload) => {
    const { id } = payload;

    try {
        const response = await Axios.put(`/store/toggle-active/${id}`, {});
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

// Custom hook for creating a plan
export const useToggleStore = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: ToggleStatusPayload) => toggleStore(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-all-stores"] }); // Adjust query key if needed
            toast.success("Store status changed.");
            console.log({ data });
        },
        onError: (error: Error) => {
            toast.error("Unable to change store status.", { description: error.message });
            console.error({ error });
        },
    });
};
